/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Selected_EventsInputs */



/**
* | output |
* | --- |
* | "Bold selected events" |
*
* @param {Bold_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bold_selected_events = /** @type {((inputs?: Bold_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre en gras les événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse (fett hervorgehoben)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi selezionati in grassetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выделенные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos seleccionados en negrita")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粗体显示的是选定的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを太字で表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चुनिंदा घटनाओं को बोल्ड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos selecionados em negrito")
	return /** @type {LocalizedString} */ ("Bold selected events")
});